<template>
  <a-modal v-model="visible" :title="'新增中文品名'" cancelText="取消" okText="确认" @ok="handleOk" v-if="visible"
    class="declaration-code-modal">
    <a-form-model :model="form" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
      <a-form-model-item required label="中文申报品名">
        <el-input v-model="form.productItemCategoryZh" />
      </a-form-model-item>
      <a-form-model-item required label="英文申报品名">
        <el-input v-model="form.productItemCategoryEn" />
        <div style="text-align: left;">
          <a @click="translate('productItemCategoryZh', 'productItemCategoryEn')">翻译</a>
        </div>
      </a-form-model-item>
      <a-form-model-item required label="编制方式和材质">
        <el-input v-model="form.compilationMethod" />
      </a-form-model-item>
      <a-form-model-item label="英文编制方式和材质">
        <el-input v-model="form.compilationMethodEn" :maxLength="100" />
        <div style="text-align: left;">
          <a @click="translate('compilationMethod', 'compilationMethodEn')">翻译</a>
        </div>
      </a-form-model-item>
      <a-form-model-item label="简易申报编码">
        <el-input v-model="form.simpleReportCode" />
      </a-form-model-item>
      <a-form-item label="站点">
        <a-checkbox-group v-model="chooseCountryList" :options="countryTabs" />
      </a-form-item>
      <a-form-model-item v-if="materialInfoRequired.JapanStation" label="日本报关编码">
        <el-input v-model="form.customsCode" />
      </a-form-model-item>
      <a-form-model-item label="韩国报关编码" v-if="materialInfoRequired.KoreaStation">
        <el-input v-model="form.customsCodeKr"></el-input>
      </a-form-model-item>
      <a-form-model-item label="英国报关编码" v-if="materialInfoRequired.UkStation">
        <el-input v-model="form.customsCodeEn"></el-input>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>
<script>
import { Modal, FormModel, Form, Checkbox } from "ant-design-vue";
import { getTranslateApi, insertCustomsApi } from '@/apis/outStock'
import { Stations } from './data'
const materialInfoRequired = {}; // 材质信息是否必选
const countryCheckList = Stations.map(x => {
  materialInfoRequired[x.value] = false;
  return {
    value: x.value,
    label: x.desc,
  }
})
export default {
  name: 'declarationCodeModal',
  components: {
    [Checkbox.Group.name]: Checkbox.Group,
    [Modal.name]: Modal,
    [FormModel.Item.name]: FormModel.Item,
    [FormModel.name]: FormModel,
    [Form.Item.name]: Form.Item,
  },
  data() {
    return {
      materialInfoRequired,
      countryTabs: countryCheckList,
      form: {
        productItemCategoryZh: "",
        productItemCategoryEn: "",
        compilationMethod: "",
        simpleReportCode: "",
        customsCode: "",
        customsCodeKr: "",
        customsCodeEn: "",
        compilationMethodEn: ''
      },
      visible: false,
      chooseCountryList: [],
      item: {},
      type: 1
    }
  },
  watch: {
    chooseCountryList: {
      handler(newValue) {
        for (let key in this.materialInfoRequired) {
          if (newValue.some(x => x === key)) {
            this.materialInfoRequired[key] = true;
          } else {
            this.materialInfoRequired[key] = false;
          }
        }
      },
      deep: true
    }
  },
  methods: {
    open(record, type) {
      // type 1 列表 2 子商品弹窗
      this.type = type
      this.item = record
      this.form = {
        productItemCategoryZh: "",
        productItemCategoryEn: "",
        compilationMethod: "",
        simpleReportCode: "",
        customsCode: "",
        customsCodeKr: "",
        customsCodeEn: "",
        compilationMethodEn: ''
      }
      this.visible = true
    },
    search(searchParams) {
      this.params = Object.assign(this.params, searchParams);
      this.params.pageNum = 1;
      this.pageInfo.current = 1;
      this.getList();
    },
    // 打开修改采购员弹窗 0-新增
    editPeople(item) {
      this.form = {};
      this.visible = !this.visible;
      if (item != 0) {
        this.isAdd = false;
        this.chooseCountryList = item.stationCode ? item.stationCode.split(",") : [];
        this.form = Object.assign({}, item);
        this.form.customsCode = this.form.customsCode ?? '';
        this.form.customsCodeKr = this.form.customsCodeKr ?? '';
        this.form.customsCodeEn = this.form.customsCodeEn ?? '';
      } else {
        this.isAdd = true;
        this.chooseCountryList = [];
        this.form = Object.assign({}, { customsCode: '', customsCodeKr: '', customsCodeEn: '' });
      }
    },
    handleOk() {
      if (!this.form.productItemCategoryZh || !this.form.productItemCategoryEn || !this.form.compilationMethod) {
        this.$message.warning("请填写完整信息");
        return
      }
      // if(this.chooseCountryList.length === 0) {
      //   this.$message.error("至少选择一个报关编码");
      //   return;
      // }

      // if(this.materialInfoRequired.JapanStation && this.form.customsCode.length === 0) {
      //   this.$message.error("日本报关编码不能为空");
      //   return
      // }
      // if(this.materialInfoRequired.KoreaStation && this.form.customsCodeKr.length === 0) {
      //   this.$message.error("韩国报关编码不能为空");
      //   return
      // }
      // if(this.materialInfoRequired.UkStation && this.form.customsCodeEn.length === 0) {
      //   this.$message.error("英国报关编码不能为空");
      //   return
      // }

      if (!this.materialInfoRequired.JapanStation) {
        this.form.customsCode = '';
      }

      if (!this.materialInfoRequired.KoreaStation) {
        this.form.customsCodeKr = '';
      }

      if (!this.materialInfoRequired.UkStation) {
        this.form.customsCodeEn = '';
      }

      this.form.stationCode = this.chooseCountryList.join(",")
      insertCustomsApi({
        ...this.form,
        productSku: this.item.productSku,
        productType: this.item.productType,
      }).then((res) => {
        if (!res.success) return
        this.$message.success('操作成功')
        this.visible = false
        this.$emit('submit',this.item, this.type)
      })
    },
    async translate(key, changeKey) {
      if (!this.form[key]) {
        this.$message.warning('请先填写内容')
        return
      }
      const { data } = await getTranslateApi({
        from: 'zh',
        text: this.form[key],
        to: 'en'
      })
      this.form[changeKey] = data.slice(0, 100)
    }
  },
}
</script>

<style lang="less">
.declaration-code-modal {
  .ant-modal-mask {

    z-index: 4000;
  }

  .ant-modal-wrap {

    z-index: 4001;
  }

  .ant-modal-body {
    padding: 10px 16px;
    overflow-y: hidden;
  }
}
</style>